import service_set from "../data_json/service_set.json";
import subscription_set from "../data_json/subscription_set.json";
import scenario_set from "../data_json/scenario_set.json";
import sharedefinitoin_set from "../data_json/sharedefinition_set.json";
import userevent_set from "../data_json/userevent_set.json";
import kkotemplate_data from "../data_json/kkotemplate_data.json";
import alertevent_set from "../data_json/alertevent_set.json";
import { getString3ByKey } from "../AdminApi/3.0_utils";

// 서비스 데이터: servId로 구하기
export const GetServiceSetData_V3 = (servID: number) => {
  const ServData = service_set.find((data) => data.SVC_ID === servID);
  return ServData;
};

// 구독 데이터: subsId로 구하기
export const GetSubscriptionSetData_V3 = (subsID: number) => {
  const SubsData = subscription_set.find((data) => data.SUBS_ID === subsID);
  return SubsData;
};

export const getScenarioData = (aprntId: number, aprentCase: number) => {
  const scenarioSet = scenario_set?.filter(
    (s) => s.APRNT_ID === aprntId && s.APRNT_CASE === (aprentCase ?? 0)
  );
  const orderedData = scenarioSet?.sort(
    (a: { SCENE_ID: number }, b: { SCENE_ID: number }) =>
      a.SCENE_ID - b.SCENE_ID
  );

  return orderedData;
};

export const getShareDefData = (shareDefId: number, shareDefCase: number) => {
  return sharedefinitoin_set?.find(
    (s) => s.SHARDEF_ID === shareDefId && s.SHARDEF_CASE === shareDefCase
  );
};

export const getUserEventData = (userEvtId: number) => {
  return userevent_set?.find((u) => u.USEREVT_ID === userEvtId);
};

export const getKkoTemplateData = (templateId: number) => {
  return kkotemplate_data?.find((k) => k.KKO_TPLID === templateId);
};

// 모든 subsname 가져오기
export const GetAllSubsnameListV3 = () => {
  const SubsData = subscription_set;

  return SubsData?.map(
    (s) => s?.SUBS_ID + "_" + getString3ByKey(s?.SUBS_NM ?? 0)
  );
};

// hide 상태 아닌 subsname 가져오기
export const GetAllNoHideSubsnameListv3 = () => {
  const SubsData = subscription_set.filter((data) => data.SUBS_ACT !== "hide");

  return SubsData?.map((s) => `${s?.SUBS_ID}_${getString3ByKey(s?.SUBS_NM)}`);
};

export const getSubscriptionNameV3 = (subsId: number) => {
  const subsData = GetSubscriptionSetData_V3(subsId);

  return getString3ByKey(subsData?.SUBS_NM ?? 0);
};
